module.exports = __webpack_public_path__ + "img/google_sync_scheduled.d2727b90.png";